
import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Provider } from "@supabase/supabase-js";
import AuthCard from "@/components/auth/AuthCard";

const Auth = () => {
  const navigate = useNavigate();
  const { signIn, signUp, signInWithProvider, user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [socialLoading, setSocialLoading] = useState<Provider | null>(null);
  
  // Redirect to home if already logged in
  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleLoginSubmit = async (email: string, password: string) => {
    setIsLoading(true);
    try {
      await signIn(email, password);
      navigate("/");
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignupSubmit = async (email: string, password: string, username: string) => {
    setIsLoading(true);
    try {
      await signUp(email, password, username);
    } catch (error) {
      console.error("Signup error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSocialLogin = async (provider: Provider) => {
    setSocialLoading(provider);
    try {
      await signInWithProvider(provider);
    } catch (error) {
      console.error(`${provider} login error:`, error);
    } finally {
      setSocialLoading(null);
    }
  };

  return (
    <div className="container flex items-center justify-center min-h-screen py-12">
      <AuthCard 
        handleLoginSubmit={handleLoginSubmit}
        handleSignupSubmit={handleSignupSubmit}
        handleSocialLogin={handleSocialLogin}
        isLoading={isLoading}
        socialLoading={socialLoading}
      />
    </div>
  );
};

export default Auth;
